export default "__VITE_ASSET__BqioxaIv__"